import { useState } from 'react';
import { Link } from 'react-router-dom';

import { appConfig } from '@/config/appConfig';
import { KaiLogo } from '@/components/branding/KaiLogo';
import { IconButton } from '@/components/ui/IconButton';
import { HelpIcon, MoonIcon, SunIcon } from '@/components/ui/Icon';
import { SupportModal } from '@/components/support/SupportModal';
import { ROUTES } from '@/routes/paths';
import { useTheme } from '@/theme/useTheme';

import { UserMenu } from './UserMenu';
import styles from './Header.module.css';

/**
 * Sticky header rendered above every authenticated page.
 *
 * On desktop the SideNav owns the brand mark — the header brand element is
 * hidden via CSS so we don't double it up. On mobile, this header is the only
 * place the brand mark appears, so it stays visible.
 */
export function Header() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to={ROUTES.dashboard} className={styles.brand} aria-label={appConfig.appName}>
          <KaiLogo size={28} label={appConfig.appName} />
        </Link>

        <div className={styles.actions}>
          <IconButton
            aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
            onClick={toggle}
            title={isDark ? 'Light mode' : 'Dark mode'}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
          </IconButton>

          <IconButton
            aria-label="Help and support"
            onClick={() => setSupportOpen(true)}
            title="Help & Support"
          >
            <HelpIcon />
          </IconButton>

          <span className={styles.divider} aria-hidden="true" />

          <UserMenu />
        </div>
      </div>
      <SupportModal open={supportOpen} onClose={() => setSupportOpen(false)} />
    </header>
  );
}
